export enum paymentMethodsActionTypes {
    FETCH_PAYMENT_METHODS_BEGIN = "FETCH_PAYMENT_METHODS_BEGIN",
    FETCH_PAYMENT_METHODS_ERROR = "FETCH_PAYMENT_METHODS_ERROR",
    FETCH_PAYMENT_METHODS_SUCCESS = "FETCH_PAYMENT_METHODS_SUCCESS"
}